import { calculateTimeBarStyle } from '@/utils/attendanceHelpers';

const TimeBar = () => <div style={calculateTimeBarStyle()} className="timebar" />;

export default TimeBar;
